import React, { useState, useEffect } from 'react';
import vr from '../../../../utils/Verifiers.jsx';
import CloseButton from '../../../sharecomponents/CloseButton.jsx';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const ImpresoraDeOrdenesTrabajoasignadas = (p) => {
    const [ordenes, setordenes] = useState([]);
    const [empleados, setempleados] = useState([]);
    const [empleadosSeleccionados, setempleadosSeleccionados] = useState({});

    const width = 1100;
    const height = width * 1.294117647058824;
    const [hojas, setHojas] = useState([]);

    useEffect(() => {
        setempleados(p.ordenes.map(o => o.nombre_empleado).sort((a, b) => a.localeCompare(b)));
        seleccionarTodosLosEmpleados();

    }, [p.ordenes])

    const seleccionarTodosLosEmpleados = () => {
        const emp = {};
        p.ordenes.forEach(ord => {
            emp[ord.nombre_empleado] = ord.labores.length;
        });
        setempleadosSeleccionados(emp);
        generarHojasImpresion(emp);
    }


    const createPDF = async () => {
        if (p.loader) p.loader(true);
        if (hojas.length === 0) return;
        const doc = new jsPDF({
            orientation: 'portrait', // 'portrait' para retrato, 'landscape' para apaisado
            unit: 'mm',
            format: [215.9, 279.4], // [ancho, alto]
        });

        for (let i = 0; i < hojas.length; i++) {
            let id = `hoja${i}`
            const componentRef = document.getElementById(id); // Reemplaza con el ID de tu componente

            if (componentRef) {
                const canvas = await html2canvas(componentRef, { scale: 1.5 });
                const imgData = canvas.toDataURL('image/png');

                // Calcula el ancho y el alto de la imagen en el PDF
                const imgWidth = 215.9; // Ancho de la página en mm (A4)
                const imgHeight = 279.4;

                // Agrega la imagen como una nueva página al PDF
                if (i > 0) {
                    doc.addPage();
                }
                doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            }
        }

        // Guarda el PDF como un solo archivo
        doc.save('labores' + (new Date()).getTime() + '.pdf');
        if (p.loader) p.loader(false);
    };

    const imprimirHoja = (indiceHoja) => {
        const elemento = document.getElementById(`hoja${indiceHoja}`);
        if (elemento) {
            // Usar las mismas dimensiones que la hoja original
            const paddingVertical = height * 0.03;
            const paddingHorizontal = width * 0.05;

            // Crear una nueva ventana para imprimir solo esta hoja
            const ventanaImpresion = window.open('', '_blank');
            ventanaImpresion.document.write(`
                <html>
                <head>
                    <title>Imprimir Hoja ${indiceHoja + 1}</title>
                    <style>
                        body { 
                            margin: 0; 
                            padding: 0; 
                            font-family: Arial, sans-serif;
                            background: white;
                        }
                        .hoja-impresion {
                            width: ${width}px;
                            height: ${height}px;
                            padding: ${paddingVertical}px ${paddingHorizontal}px;
                            background: white;
                            margin: 0 auto;
                            box-sizing: border-box;
                        }
                        .bg-white5 { background-color: #f8f9fa !important; }
                        .bg-white { background-color: #ffffff !important; }
                        .border-bottom { border-bottom: 1px solid #000 !important; }
                        .border-dark { border-color: #000 !important; }
                        .h5 { 
                            font-size: 1.25rem !important; 
                            margin: 0.5rem 0 !important;
                            font-weight: 500 !important;
                        }
                        .text-bold { font-weight: bold !important; }
                        .text-s { font-size: 0.875rem !important; }
                        .lh1 { line-height: 1 !important; }
                        .w-100 { width: 100% !important; }
                        .m-1 { margin: 0.25rem !important; }
                        .p-0 { padding: 0 !important; }
                        .ps-2 { padding-left: 0.5rem !important; }
                        .pe-2 { padding-right: 0.5rem !important; }
                        .me-2 { margin-right: 0.5rem !important; }
                        .ms-2 { margin-left: 0.5rem !important; }
                        .ms-3 { margin-left: 1rem !important; }
                        .mt-3 { margin-top: 1rem !important; }
                        .mb-0 { margin-bottom: 0 !important; }
                        .ms-0 { margin-left: 0 !important; }
                        .me-0 { margin-right: 0 !important; }
                        .text-start { text-align: left !important; }
                        .col-lg-12 { width: 100% !important; }
                        .row { 
                            display: flex !important;
                            flex-wrap: wrap !important;
                            margin: 0 !important;
                        }
                        .justify-content-start { justify-content: flex-start !important; }
                        
                        @media print {
                            body { margin: 0; padding: 0; }
                            .hoja-impresion {
                                width: ${width}px !important;
                                height: ${height}px !important;
                                padding: ${paddingVertical}px ${paddingHorizontal}px !important;
                            }
                            @page {
                                size: ${width + 40}px ${height + 40}px;
                                margin: 20px;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="hoja-impresion">
                        ${elemento.innerHTML}
                    </div>
                </body>
                </html>
            `);
            ventanaImpresion.document.close();
            setTimeout(() => {
                ventanaImpresion.print();
                ventanaImpresion.close();
            }, 250);
        }
    };

    const conversorHoraAmillisegundos = (hora) => {
        const [h, m] = hora.split(":").map(Number);
        return (m + h * 60) * 60000;
    }

    const millisegundosAHora = (ms) => {
        const totalMinutos = Math.floor(ms / 60000);
        let horas = Math.floor(totalMinutos / 60);
        const minutos = totalMinutos % 60;
        while (horas >= 24) horas -= 24;
        const meridiano = horas >= 12 ? "pm" : "am";
        const horasFormato12 = horas % 12 || 12;

        return `${horasFormato12.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')} ${meridiano}`;
    }

    const generarHojasImpresion = (empleados) => {
        const ordenes_show = p.ordenes.map(o => {
            if (empleados[o.nombre_empleado]) return o;
            else return null;
        }).filter(o => o);

        ordenes_show.sort((a, b) => a.nombre_empleado.localeCompare(b.nombre_empleado));

        const hojas_maker = [];
        let hojaActual = [];
        const alturaMaxima = Math.floor(height * .95);
        let contadorAltura = 0;
        const alturaTitulo = 50;
        const alturaLabor = 25;

        ordenes_show.forEach(orden => {
            const altura = alturaTitulo + alturaLabor + contadorAltura;
            if (altura > alturaMaxima) {
                hojas_maker.push([...hojaActual]);
                hojaActual = [];
                contadorAltura = 0;
            }
            contadorAltura += alturaTitulo;
            hojaActual.push({ tipo: "nombre_empleado", valor: (<div className='col-lg-12 mt-3 mb-0 p-0 ms-0 me-0 text-start h5 text-bold lh1'>{orden.nombre_empleado}</div>) });
            let horaInicial = conversorHoraAmillisegundos("07:00");

            orden.labores.forEach(lab => {
                let nuevaHora = horaInicial + (lab.labor.ms_by_unidad * lab.asignado);
                const altura_lab = alturaLabor + contadorAltura;
                if (altura_lab > alturaMaxima) {
                    hojas_maker.push([...hojaActual]);
                    hojaActual = [];
                    contadorAltura = 0;
                }

                contadorAltura += alturaLabor;
                hojaActual.push({
                    tipo: "labor", valor: (<div className='w-100 m-0 p-0 ps-2 pe-2 p-0 lh1'>
                        <span className='me-2'>{lab.labor.labor}</span>
                        <span className='text-bold text-s'>{lab.asignado} {lab.labor.um}</span>
                        <span className='ms-3'>{millisegundosAHora(horaInicial)} - {millisegundosAHora(nuevaHora)}</span>
                        {lab.semana_siembra != "N/A" && <span className='ms-3'>
                            <span className='text-bold'>Siembra: </span>
                            {lab.semana_siembra.split(",").join(", ")}
                        </span>}
                    </div>)
                });
                horaInicial = nuevaHora;

            });

        });
        if (hojaActual.length > 0) hojas_maker.push([...hojaActual]);
        setHojas(hojas_maker);
    }

    return (
        <div className='vw-100 vh-100 bg-black5 blur-xl' style={{ ...vr.floatPageStyle(), overflow: "auto" }}>

            <div className='row justify-content-around w-100 m-0 p-0'>
                <div className='p-0 m-0 bg-white2 shadow mb-4' style={{ width: "100%", maxWidth: "1600px" }}>
                    <CloseButton close={p.close} floatElement={true} />
                    <div className='row justify-content-around w-100 m-0 p-0'>
                        <div className='col-lg-12 bg-white text-center h4 tex-300 pt-2 pb-2'>Impresión de labores asignadas</div>
                        {empleados.map((e, i) => <div className='bw-300 m-2 p-0' key={e + "empdiv" + i}>
                            <button
                                onClick={() => {
                                    const emps = { ...empleadosSeleccionados };
                                    if (emps[e]) delete emps[e];
                                    else emps[e] = p.ordenes.find(o => o.nombre_empleado === e)?.labores.length ?? 0;
                                    setempleadosSeleccionados(emps);
                                    generarHojasImpresion(emps);
                                }}
                                className={`btn btn-sm btn-${empleadosSeleccionados[e] ? 'warning' : 'light shadow'} w-100`} key={e + "emp" + i}>
                                {e} ({empleadosSeleccionados[e] ?? 0})
                            </button>
                        </div>)}
                        <div className='w-100 m-0 p-0 mb-3'></div>
                        <div className='bw-300 m-2 p-0'>
                            <button
                                onClick={() => { seleccionarTodosLosEmpleados(); }}
                                className={`btn btn-sm btn-light border border-info text-blue4 w-100 text-bold`} >Seleccionar todo</button>
                        </div>
                        <div className='bw-300 m-2 p-0'>
                            <button
                                onClick={() => { setempleadosSeleccionados({}); generarHojasImpresion({}); }}
                                className={`btn btn-sm btn-light border border-danger text-red4 w-100 text-bold`} >Deseleccionar todo</button>
                        </div>
                        <div className='bw-300 m-2 p-0'>
                            <button className='btn btn-sm btn-danger bg-red4 text-white w-100 text-bold5' onClick={() => hojas.length > 0 ? createPDF() : {}} >
                                <i className={`text-white ms-3 fa fa-file-pdf me-2`} ></i>
                                Descargar {hojas.length} hoja(s)
                            </button>
                        </div>

                    </div>
                </div>
                {hojas.map((h, i) => <div key={i + "hoja"} className='bg-white m-0 mt-2 mb-4 position-relative' id={"hoja" + i} style={{ height: `${height}px`, width: `${width}px`, padding: `${height * 0.04}px ${width * 0.05}px` }}>
                    <button
                        onClick={() => imprimirHoja(i)}
                        className='btn btn-light border shadow-sm position-absolute'
                        style={{
                            top: '10px',
                            right: '10px',
                            zIndex: 5,
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        title={`Imprimir Hoja ${i + 1}`}
                    >
                        <svg width="16" height="16" fill="currentColor" className="text-dark" viewBox="0 0 16 16">
                            <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                            <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                        </svg>
                    </button>
                    <div className='row justify-content-start w-100 p-0 m-0 bg-white5'>
                        {h.map((item, j) => <div key={j + "item"} className='w-100 m-1 p-0'>
                            {item.valor}
                        </div>)}
                    </div>
                </div>)}
            </div>
        </div >
    )
}

export default ImpresoraDeOrdenesTrabajoasignadas;